import axios from 'axios';

export default {
  customAxios() {
    return axios.create({
      baseURL : process.env.GAIA_LITE_BFF_API,
      headers : {
        Authorization: `Bearer ${window?.$nuxt?.$token?.get()}`
      }
    });
  }
};
